export class Detectors {
    static isTouchDevice() {
        return 'ontouchstart' in window || !!navigator.maxTouchPoints;
    }
    static isInternetExplorer() {
        return /MSIE \d|Trident.*rv:/.test(navigator.userAgent);
    }
}
export default Detectors;
